<template>
  <div class="container company__land">
    <div class="company__wrp">
      <img
        class="company__logo"
        src="/dist/assets/front_white/img/ifc/ifcLogo.svg"
        alt="Логотип IFC"
        width="98px"
        height="50px"
        style="width: 98px; height: 50px;"
      />
      <bim-text type="h5" class="my-6" bold>Модели IFC</bim-text>
      <bim-text type="accent">
        Каталог моделей в формате IFC (Industry Foundation Classes). Один из ключевых форматов для BIM.
        <br>Ответственным за разработку является консорциум <a class="company__link" href="/buildingsmart/?from=ifc" target="_blank">buildingSMART International.</a>
      </bim-text>
    </div>

    <search-block
      searchPlaceholder="Поиск по библиотеке моделей IFC"
      :attributeNumber="1582"
    />
  </div>
</template>

<script>
  import SearchBlock from './components/search-block'

  export default {
    name: 'IFC',
    components: {
      SearchBlock,
    },
  }
</script>

<style lang="scss" scoped>
  @import "./src/front_white/sass/components/settings";

  .company__land {
    min-height: 700px;
  }

  .company__wrp {
    padding: 64px 0;
    text-align: center;
    color: $black-color;
  }

  .company__logo {
    width: 108px;
    height: 108px;
    margin: 0 auto;
  }

  .title {
    font-size: 32px;
  }


  .description {
    margin-top: 17px;
  }

  .bim__20 {
    width: 20px;
    margin-right: 10px;
  }

  .company__link {
    color: $primary-color;

    &:hover {
      opacity: .8;
    }
  }

  @media all and (max-width: $breakpoint-sm) {
    .company__wrp {
      padding: 40px 0;
    }
  }
</style>
